import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"

export type  DefinirAliquotaItemParams = {
    identificadorItem:number,
    aliquota: number,
    atualizarEstadoLegadoImediatamente?: boolean
    itemOrcamentoLegado?: any
}


export async function definirAliquotaItem(params: DefinirAliquotaItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirAliquotaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem, 
            params.aliquota)

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

    }finally {
        globalMU.unblockUI()
    }
}